export default {
  title: "Registro",
  welcomeTitle: "Bem-vindo(a) ao Prodgy",
  welcomeDescription: "Complete seu registro para acessar a plataforma",
  formFields: {
    password: "Senha",
    confirmPassword: "Confirme sua senha",
    passwordPlaceholder: "Digite sua senha",
    confirmPasswordPlaceholder: "Digite sua senha novamente",
  },
  validation: {
    passwordMinLength: "A senha deve ter pelo menos 8 caracteres",
    passwordRequirements: "A senha deve conter pelo menos uma letra maiúscula, uma minúscula e um número",
    passwordsMustMatch: "As senhas devem ser idênticas",
  },
  userInfo: {
    title: "Suas informações",
    name: "Nome",
    email: "Email",
    role: "Função",
    roleAdmin: "Administrador",
    roleUser: "Usuário",
  },
  buttons: {
    createAccount: "Começar Agora",
    creatingAccount: "Processando...",
    goToLogin: "Ir para página de login",
  },
  errors: {
    invalidInvite: "Convite inválido. Por favor, verifique o link que você recebeu.",
    expiredInvite: "Este convite não é válido ou já expirou.",
    validationError: "Erro ao validar convite. Por favor, tente novamente ou entre em contato com o suporte.",
    registrationError: "Ocorreu um erro ao registrar sua conta. Por favor, tente novamente.",
    passwordSetupFailed: "Erro ao definir senha.",
    autoLoginFailed: "Erro ao fazer login automático:",
    registrationProcessError: "Erro ao finalizar cadastro:",
    tokenUsed: "Este link de convite já foi utilizado ou foi cancelado.",
    contactAdmin: "Se você precisar de ajuda, entre em contato com o administrador do sistema.",
    title: "Erro",
    validationTitle: "Não foi possível validar seu convite",
    expiredTitle: "Link Expirado",
    expiredDescription: "O link de convite já não é mais válido",
    usedTitle: "Link Já Utilizado",
    usedDescription: "Este link de convite já foi usado",
    invalidTitle: "Link Inválido",
    invalidDescription: "O link de convite não é válido",
    PASSWORD_TOO_LONG: "A senha não pode ter mais de 72 caracteres.",
    DEFAULT: "Erro ao definir senha.",
    passwordErrorTitle: "Erro na Senha",
  },
  success: {
    title: "Senha definida!",
    description: "Sua conta foi configurada com sucesso",
    message: "Você será redirecionado automaticamente para o Prodgy...",
  },
  passwordRequirements: {
    title: "Requisitos de senha",
    minChars: "Mínimo de 8 caracteres",
    upperCase: "Pelo menos uma letra maiúscula (A-Z)",
    lowerCase: "Pelo menos uma letra minúscula (a-z)",
    number: "Pelo menos um número (0-9)",
    specialChar: "Pelo menos um caractere especial (!@#$...)",
    match: "As senhas devem coincidir",
  },
  agreeTermsStart: "Ao concluir o cadastro, você concorda com os ",
  agreeTermsMiddle: "e",
  agreeTermsEnd: ".",
  termsOfService: "Termos de Serviço",
  privacyPolicy: "Política de Privacidade",
  checking: "Verificando seu convite...",
  redirecting: "Redirecionando para a página inicial...",
  pleaseWait: "Por favor, aguarde um momento.",
  common: {
    poweredBy: "Desenvolvido por",
    companyName: "Programmers",
    trademark: "®",
    appName: "Prodgy",
    error: "Erro",
    success: "Sucesso",
    errorClearingSession: "Erro ao limpar sessão, continuando mesmo assim:"
  },
  resetPassword: {
    title: "Redefinir Senha",
    description: "Digite sua nova senha abaixo",
    validatingToken: "Validando seu link de redefinição...",
    invalidToken: "Link de Redefinição Inválido",
    tokenExpiredOrInvalid: "O link de redefinição de senha é inválido ou expirou",
    requestNewLink: "Por favor, solicite um novo link de redefinição de senha",
    backToLogin: "Voltar para login",
    successTitle: "Senha Redefinida com Sucesso!",
    successDetail: "Sua senha foi redefinida com sucesso",
    redirecting: "Você será redirecionado para a página de login em instantes...",
    newPassword: "Nova Senha",
    confirmPassword: "Confirmar Senha",
    requirements: "Requisitos de Senha",
    reqMinLength: "Mínimo de 8 caracteres",
    reqUppercase: "Pelo menos uma letra maiúscula",
    reqLowercase: "Pelo menos uma letra minúscula",
    reqNumber: "Pelo menos um número",
    reqSpecial: "Pelo menos um caractere especial",
    processing: "Processando...",
    submit: "Redefinir Senha",
    genericError: "Ocorreu um erro ao redefinir sua senha",
    invalidRequest: "Solicitação de redefinição inválida",
    successMessage: "Senha redefinida com sucesso",
    errorResetting: "Erro ao redefinir senha:",
    sessionCleared: "Sessão encerrada silenciosamente para o processo de redefinição de senha"
  }
} as const;
